import { Component, OnInit, AfterViewChecked, ViewEncapsulation, ElementRef, HostListener } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { CHART_CONFIG } from 'config';

import { DashboardService } from './shared/providers/dashboard.service';

import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { DonutChartModel } from 'lib/ng2-sapmp/src/ui-components/charts/donut-chart';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DashboardService],
  encapsulation: ViewEncapsulation.None
})
export class DMPManageDashboardComponent implements OnInit, AfterViewChecked {

  manageInventoryPage: any;
  chartLabel: any;
  chartData: any;
  legendData: any;
  chartRadius = 90;
  strokeWidth = 20;
  startIndex = 0;
  recordsPerPage = 9;
  fanDevicesReq: any;
  isSearch: boolean;
  fanSearch: FormControl;
  fieldPermissions: any;
  smsSent: boolean;
  companyId = 0;
  fanStatus: any;
  dashboardData: any;
  showData: boolean;
  appleInstalled: any;
  apiError: boolean;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const addpDashboardContainer = this.el.nativeElement.getElementsByClassName('addp-dashboard-container');
    if (addpDashboardContainer.length) {
      if (window.innerWidth <= 1024) {
        addpDashboardContainer[0].style.height = 'auto';
        addpDashboardContainer[0].classList.remove('height-set');
      } else {
        addpDashboardContainer[0].style.height = addpDashboardContainer[0].clientHeight + 'px';
        addpDashboardContainer[0].classList.add('height-set');
      }
    }
  }

  constructor(private pageloaderService: PageLoaderService,
    private dashboardService: DashboardService,
    private breadCrumbService: BreadCrumbService,
    private utilityService: UtilityService,
    private route: ActivatedRoute, private router: Router,
    private el: ElementRef) {
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.breadCrumbService.setStaticBreadCrumbs(this.router.routerState.snapshot.url);
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Console Dashboard', routerLink: '/dashboard' });
    this.dashboardService.getDashboardContent(this.utilityService.getEnvConfig().contentUrl.dashboard.dashboardData).
      subscribe(respobj => {
        this.dashboardData = respobj;
        this.dashboardData.useMock = this.utilityService.getEnvConfig().useMock;
        const profileData = JSON.parse(sessionStorage.getItem('user'));
        this.dashboardData.customerName = this.dashboardData.customerName.replace('<customer name>',
          profileData.user.firstName + ' ' + profileData.user.lastName);
        this.initPage();
      });
  }

  ngAfterViewChecked() {
    const addpDashboardContainer = this.el.nativeElement.getElementsByClassName('addp-dashboard-container');
    if (addpDashboardContainer.length && window.innerWidth >= 1025) {
      addpDashboardContainer[0].style.height = addpDashboardContainer[0].clientHeight + 'px';
      addpDashboardContainer[0].classList.add('height-set');
    }
  }

  initPage(scenarios?) {
    if (typeof scenarios !== 'undefined') {
      this.companyId = scenarios;
    }

    this.showData = false;
    this.pageloaderService.setPageLoaderStatus(false);
    this.chartData = {};
    this.legendData = {};
    this.chartLabel = {};

    this.dashboardService.getFanStatusSummary(this.companyId).subscribe(respobj => {
      this.fanStatus = respobj;

      this.dashboardData.manageDeployment.firstTimeUser =
        this.dashboardData.manageDeployment.firstTimeUser.replace('<noOfFans>', respobj.noOfFans);
      this.dashboardData.manageDeployment.deviceEnrolledContent =
        this.dashboardData.manageDeployment.deviceEnrolledContent.replace('<noOfFans>', respobj.noOfFans);
      this.dashboardData.manageDeployment.setupIncompleteContent =
        this.dashboardData.manageDeployment.setupIncompleteContent.replace('<noOfFans>', respobj.noOfFans);
      this.dashboardData.deviceInventory.setupCompleted =
        this.dashboardData.deviceInventory.setupCompleted.replace('<noOfDevices>', respobj.noOfDevices);
      this.appleInstalled = this.dashboardData.appleCertificate[this.fanStatus.appleCertificate];

      if (respobj.initialSignupStatus === 'Completed') {
        this.buildChartData(respobj.fansSummary, 'accounts', 'accounts');
      }
      if (respobj.deviceEnrolledStatus === 'Completed') {
        this.buildChartData(respobj.deviceInventoryEnrollSummary, 'devices', 'devices');
      }
      if (respobj.deviceEnrolledStatus === 'Error') {
        this.buildErrorChartData();
      }
      this.pageloaderService.setPageLoaderStatus(true);
      this.showData = true;
    }, error => this.handleError(error));
  }

  handleError(error) {
    this.apiError = true;
    this.pageloaderService.setPageLoaderStatus(true);
  }

  navigate(route) {
    this.router.navigate([route]);
  }

  buildErrorChartData() {
    this.chartData['error'] = [];
    this.chartLabel['error'] = 'devices';
    const temp = {
      'value': 0,
      'color': '#ccc',
      'legend': 'Error'
    };
    this.chartData['error'].push(temp);
  }

  buildChartData(fanDetails, type, label) {
    this.chartData[type] = [];
    this.legendData[type] = { left: [], right: [] };
    this.chartLabel[type] = label;
    fanDetails.forEach((d, i) => {
      const chartConfig = CHART_CONFIG[d.status];
      const temp: DonutChartModel = {
        'value': d.count,
        'color': chartConfig.color,
        'legend': d.count + ' ' + chartConfig.label
      };
      if (d.count) {
        this.chartData[type].push(temp);
      }
      this.legendData[type][fanDetails.length / 2 > i ? 'left' : 'right'].push(temp);
    });
  }
}
